/**
 * Created by Rodrigo Quesada on 24/03/17.
 */

export class EmptyClass {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/common/mixins/empty-class.class.ts